<template>
  <div v-if="nextRecord || prevRecord" class="flex items-center justify-end">
    <button
      :disabled="!prevRecord"
      @click="viewPrevious"
      class="p-2 border border-slate-200 rounded mr-1"
      :class="{ 'cursor-not-allowed opacity-20': !prevRecord }"
      data-track="clicked-candidate-arrow-navigation"
    >
      <vue-feather type="chevron-left" class="h-4" />
    </button>
    <button
      :disabled="!nextRecord"
      @click="viewNext"
      class="p-2 border border-slate-200 rounded"
      :class="{ 'cursor-not-allowed opacity-20': !nextRecord }"
      data-track="clicked-candidate-arrow-navigation"
    >
      <vue-feather type="chevron-right" class="h-4" />
    </button>
  </div>
</template>

<script>
export default {
  computed: {
    filteredContacts() {
      return this.$store.state.general.contactListContext.records;
    },
    currentIndex() {
      return this.$store.state.general.contactListContext.currentIndex;
    },
    prevRecord() {
      return this.filteredContacts[this.currentIndex - 1];
    },
    nextRecord() {
      return this.filteredContacts[this.currentIndex + 1];
    },
  },
  methods: {
    async viewPrevious() {
      const self = this;

      const id = self.prevRecord.id;

      this.$store.commit('general/setContactListContext', {
        records: self.filteredContacts,
        currentIndex: self.currentIndex - 1,
      });
      await this.$router.push({ name: 'CandidateDetail', params: { id } });
      this.$emit('update');
    },
    async viewNext() {
      const self = this;

      const id = self.nextRecord.id;

      this.$store.commit('general/setContactListContext', {
        records: self.filteredContacts,
        currentIndex: self.currentIndex + 1,
      });
      await this.$router.push({ name: 'CandidateDetail', params: { id } });
      this.$emit('update');
    },
  },
};
</script>
